"use client"

import { useEffect, useRef } from "react"
import "./WebflowSupport.css"

const WebflowSupport = () => {
  const headerRef = useRef(null)
  const descriptionRef = useRef(null)
  const cardsRef = useRef(null)

  const packages = [
    {
      title: "ESSENTIAL",
      features: [
        { text: "Updates on the website content and metadata", included: true },
        { text: "Analytics tracking and reporting", included: true },
        { text: "Performance optimisation", included: true },
        { text: "Basic security", included: true },
        { text: "Optimised performance", included: true },
        { text: "SEO Audit on the template and optimisation", included: true },
        { text: "User experience UX analysis and improvements", included: true },
        { text: "Improving readability", included: false },
        { text: "Contact & A testing", included: false },
        { text: "Campaign optimisation", included: false },
      ],
    },
    {
      title: "IMPROVEMENT",
      features: [
        { text: "Updates on the website content and metadata", included: true },
        { text: "Analytics tracking and reporting", included: true },
        { text: "Performance optimisation", included: true },
        { text: "Basic security", included: true },
        { text: "Optimised performance", included: true },
        { text: "SEO Audit on the template and optimisation", included: true },
        { text: "User experience UX analysis and improvements", included: true },
        { text: "Improving readability", included: true },
        { text: "Contact & A testing", included: true },
        { text: "Campaign optimisation", included: false },
      ],
    },
    {
      title: "GROWTH",
      features: [
        { text: "Updates on the website content and metadata", included: true },
        { text: "Analytics tracking and reporting", included: true },
        { text: "Performance optimisation", included: true },
        { text: "Basic security", included: true },
        { text: "Optimised performance", included: true },
        { text: "SEO Audit on the template and optimisation", included: true },
        { text: "User experience UX analysis and improvements", included: true },
        { text: "Improving readability", included: true },
        { text: "Contact & A testing", included: true },
        { text: "Campaign optimisation", included: true },
      ],
    },
  ]

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible")
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.1 },
    )

    if (headerRef.current) observer.observe(headerRef.current)
    if (descriptionRef.current) observer.observe(descriptionRef.current)
    if (cardsRef.current) observer.observe(cardsRef.current)

    return () => {
      if (headerRef.current) observer.unobserve(headerRef.current)
      if (descriptionRef.current) observer.unobserve(descriptionRef.current)
      if (cardsRef.current) observer.unobserve(cardsRef.current)
    }
  }, [])

  return (
    <section className="webflow-support-section">
      <div className="container">
      <div className="webflow-support-wrapper">
        {/* Header Section */}
        <div className="webflow-support-header">
          <div className="header-content animate-left" ref={headerRef}>
            <h2 className="webflow-support-title">
              OUR WEBFLOW <span className="highlight">POST</span>
              <br />
              <span className="highlight">LAUNCH SUPPORT</span>
            </h2>
          </div>
          <div className="description-content animate-right" ref={descriptionRef}>
            <p className="webflow-support-description">
              We work with you to get your software up and running, then provide ongoing website development support so
              that the site stays that way. Whether you need optimisation, corrections, new features added, or just a
              refresh to an existing page, we guarantee quality work with our unique flexible maintenance packages.
              These include all the necessary procedures to keep your Webflow website performing optimally, and fit to
              your maintenance requirements.
            </p>
          </div>
        </div>

        {/* Packages Section */}
        <div className="packages-section">
          <h3 className="packages-title">
            CHECK OUT OUR <span className="highlight">POST LAUNCH SUPPORT</span>
          </h3>

          <div className="packages-grid animate-up" ref={cardsRef}>
            {packages.map((pkg, index) => (
              <div key={index} className="package-card" style={{ "--animation-delay": `${index * 0.2}s` }}>
                <div className="package-header">
                  <h4 className="package-title">{pkg.title}</h4>
                </div>

                <div className="package-features">
                  {pkg.features.map((feature, featureIndex) => (
                    <div key={featureIndex} className="feature-item">
                      <div className={`checkmark ${feature.included ? "included" : "not-included"}`}>✓</div>
                      <span className="feature-text">{feature.text}</span>
                    </div>
                  ))}
                </div>

                <button className="quote-button">GET A FREE QUOTE</button>
              </div>
            ))}
          </div>

          
        </div>
      </div>
      </div>
    </section>
  )
}

export default WebflowSupport
